import { gql, useQuery } from "@apollo/client";
import { singleAdRequestOperationQuery, SingleAdRequestOperation } from "__generated__/api";
import SingleAdRequest = SingleAdRequestOperation.SingleAdRequest;

const singleAdRequestOperation = gql`
  ${singleAdRequestOperationQuery}
`;

export type SingleAdRequestResponse = { singleAdRequest: SingleAdRequest };

export function useSingleAdRequestOperationQuery(variables: SingleAdRequestOperation.Variables) {
  return useQuery<SingleAdRequestResponse>(singleAdRequestOperation, {
    variables,
    ssr: false,
    fetchPolicy: "no-cache",
  });
}

export default useSingleAdRequestOperationQuery;
